import React from 'react';

import { Box, HStack, Text, VStack } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { A11yWrapper } from 'components/a11y-wrapper';
import { StoreSanityOrderEta } from 'components/sanity-store-order-eta/store-sanity-order-eta';
import { Halal } from 'components/ucl/svgs/Halal';

import { Address, ServiceModes, Status, StoreCardViewContainer } from '../store-card.styled';
import { StoreCardDetailsProps } from '../types';

import { StoreCardMessages } from './store-card-messages';

export const StoreCardDetails: React.FC<StoreCardDetailsProps> = ({
  errorMessage,
  storeDetails,
  distanceComponent,
}) => {
  const { formatMessage } = useIntl();
  const {
    restaurantStatus,
    serviceModesText,
    address,
    city,
    isHalal,
    accessInstructions,
    isNonTraditionalStore,
  } = storeDetails;

  return (
    <StoreCardViewContainer>
      {address && (
        <VStack focusable={false}>
          <HStack justifyContent={'space-between'}>
            <Address underline={false}>{address}</Address>
            <StoreSanityOrderEta store={storeDetails.restaurant} />
          </HStack>
          <HStack alignItems={'baseline'} justifyContent={'start'} width={'full'}>
            <Box flexDirection={'row'} alignItems={'center'}>
              <Text variant="copyTwo">{city}</Text>
              <Text>{' • '}</Text>
            </Box>
            <Box>
              <A11yWrapper alignItems={'center'}>
                <Status
                  isWithinOneHourOfClose={restaurantStatus.isWithinOneHourOfClose}
                  isOpen={restaurantStatus.isOpen}
                >
                  {restaurantStatus.text}
                </Status>
              </A11yWrapper>
            </Box>
          </HStack>
        </VStack>
      )}
      {isHalal && <Halal title={formatMessage({ id: 'isHalalTitle' })} />}
      {serviceModesText && (
        <HStack alignItems="center" justifyContent={'space-between'} focusable>
          <ServiceModes>{serviceModesText}</ServiceModes>
          {distanceComponent}
        </HStack>
      )}

      <StoreCardMessages
        errorMessage={errorMessage}
        accessInstructions={isNonTraditionalStore ? accessInstructions : ''}
      />
    </StoreCardViewContainer>
  );
};
